import React from "react";
import NumberFormat from "react-number-format";
import { calculateAssessedValue } from "../../../../helpers/utils/OrderDetailUtils";

type Props = {
    setCertificate: any;
    certificate: any;
    showAccount: number;
    index: number;
    name: string;
    setName: any;
    setProductTypeInvisible: any;
    editable: boolean;
    setIsSavedResult: any;
    setRender?: any;
};

const AssessmentsRowFormatting: React.FC<Props> = ({
                                                       setCertificate,
                                                       certificate,
                                                       showAccount,
                                                       index,
                                                       name,
                                                       setName,
                                                       setProductTypeInvisible,
                                                       editable,
                                                       setIsSavedResult,
                                                       setRender,
                                                   }) => {
    const curAccount = certificate.accounts?.[showAccount];
    const validAssessment =
        Array.isArray(curAccount?.assessments) && curAccount.assessments[index];

    if (!validAssessment) return null;

    const rawValue = curAccount.assessments[index]?.[name];
    const formattedValue =
        rawValue !== null && rawValue !== undefined ? rawValue.toString() : "";

    const handleChange = (e: any) => {
        const value = e.target.value;
        const cleaned =
            value !== "" && value !== null
                ? parseFloat(value.replace("$", "").replaceAll(",", ""))
                : null;

        setCertificate((prev: any) => {
            const updatedAccounts = prev.accounts.map((acc: any, accIdx: number) => {
                if (accIdx !== showAccount) return acc;

                const updatedAssessments = acc.assessments.map((assessment: any, aIdx: number) => {
                    if (aIdx !== index) return assessment;
                    return {
                        ...assessment,
                        [name]: cleaned,
                    };
                });

                return {
                    ...acc,
                    assessments: updatedAssessments,
                    taxDataSource: "EDITOR",
                    asOfDate: new Date(),
                };
            });

            return {
                ...prev,
                accounts: updatedAccounts,
            };
        });

        if (name === "homesteadCapValue") {
            const updatedAssessment = {
                ...curAccount.assessments[index],
                [name]: cleaned,
            };
            calculateAssessedValue(showAccount, updatedAssessment, setRender, setCertificate).then();
        }

        setName(name);
        setProductTypeInvisible(value + new Date().getTime());
        setIsSavedResult(false);
    };

    return (
        <NumberFormat
            placeholder={formattedValue === "" ? "N/A" : "..."}
            className={`form-control ${!editable ? "border border-text-1 bg-surface-5 text-surface-3" : ""}`}
            decimalScale={2}
            decimalSeparator="."
            isNumericString={true}
            value={formattedValue}
            prefix={formattedValue !== "" ? "$" : ""}
            id={`${name}-${index}`}
            onChange={handleChange}
            thousandSeparator={true}
            readOnly={!editable}
        />
    );
};

export default AssessmentsRowFormatting;
